import React from 'react';

import {ExperimentStatus, ExperimentTestingModel} from 'iron/apps/experiments/src/types';

import {useStagedExperiment} from './staged-experiment';

export const useTestingModelModifiers = () => {
  const {stagedExperiment: experiment} = useStagedExperiment();

  const noPeeking = React.useMemo(() => {
    if (experiment?.settings?.testingModel !== ExperimentTestingModel.FREQUENTIST) {
      return false;
    }
    return [ExperimentStatus.DRAFT, ExperimentStatus.ACTIVE].includes(experiment?.status ?? ExperimentStatus.DRAFT);
  }, [experiment?.status, experiment?.settings?.testingModel]);

  return {
    noPeeking,
  };
};
